import type { BrandSpecial, UserSegmentIds } from '@iheartjane/data-access';
import { brandSpecialHasSegments } from '@iheartjane/menu';
import type { BrandSpecialUserSegmentIds } from '@iheartjane/types';

/* eslint-disable-next-line no-restricted-imports */
import type { PendingCartProduct } from '@jane/shared/models';

export const brandSpecialOrProductHasSegments = ({
  brandSpecial,
  cartProduct,
  product,
}: {
  brandSpecial?: Pick<BrandSpecial, 'special_type' | 'rules'>;
  cartProduct?: Pick<PendingCartProduct, 'brand_special_has_segment_rules'>;
  product?: {
    applicable_brand_specials_excluded_user_segments?:
      | BrandSpecialUserSegmentIds
      | readonly number[];
    applicable_brand_specials_included_user_segments?:
      | BrandSpecialUserSegmentIds
      | readonly number[];
  };
}) => {
  if (brandSpecial) {
    return brandSpecialHasSegments({
      rules: brandSpecial.rules,
      specialType: brandSpecial.special_type,
    });
  }

  if (
    product &&
    'applicable_brand_specials_included_user_segments' in product &&
    'applicable_brand_specials_excluded_user_segments' in product
  ) {
    const includedSegments =
      product.applicable_brand_specials_included_user_segments;
    const excludedSegments =
      product.applicable_brand_specials_excluded_user_segments;
    const noIncludedSegments =
      !includedSegments ||
      includedSegments === -1 ||
      !(includedSegments as UserSegmentIds).length;
    const noExcludedSegments =
      !excludedSegments ||
      excludedSegments === -1 ||
      !(excludedSegments as UserSegmentIds).length;
    const needsSegments = !noIncludedSegments || !noExcludedSegments;

    return needsSegments;
  }

  if (cartProduct) {
    return Boolean(cartProduct.brand_special_has_segment_rules);
  }

  return false;
};
